import { render, staticRenderFns } from "./ContactActionsHistory.vue?vue&type=template&id=4c846de1&scoped=true&"
import script from "./ContactActionsHistory.vue?vue&type=script&lang=js&"
export * from "./ContactActionsHistory.vue?vue&type=script&lang=js&"
import style0 from "./ContactActionsHistory.vue?vue&type=style&index=0&id=4c846de1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c846de1",
  null
  
)

export default component.exports